import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import SiteHeader from '@/components/generals/site-header'
import SiteFooter from '@/components/generals/site-footer'
import { defaultLayoutData } from '@/constants/site'

export const Layout: FC<LayoutProps> = ({ children, layout }): ReactNode => {
    const data = layout ?? defaultLayoutData

    return (
        <div className='flex min-h-screen flex-col bg-background text-foreground'>
            <a
                href='#contenido'
                className='sr-only z-50 rounded-sm bg-brass px-4 py-3 text-xs font-semibold uppercase tracking-[0.2em] text-black focus:not-sr-only focus:fixed focus:top-4 focus:left-4'
            >
                Saltar al contenido
            </a>

            <SiteHeader categorias={data.categorias} />

            <main id='contenido' className='flex-1'>
                {children}
            </main>

            <SiteFooter ajustes={data.ajustes} categorias={data.categorias} />
        </div>
    )
}
